import { createDebugger, createLazyDebugger } from '@iotize/common/debug';

const prefix = '@iotize/tap';

export const lazyDebug = createLazyDebugger(prefix);
export const debug = createDebugger(prefix);
